<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box account_input">
        <div class="accountright_cont_box">
          <h2 class="history_box-head flex_center_between_box">
            {{ $t("OrganizationalManagement.Groups") }}
            <button class="btn_blue flex_center add_btn" @click="searchHistory">
              {{ $t("OrganizationalManagement.NewlyBuilt") }}
              <!-- <img src="../../assets/img/detail/btn_ic5.png" /> -->
            </button>
          </h2>
          <div class="flex_center_between_box">
            <div style="display: flex">
              <div class="sel_box">
                <el-input
                  class="inline-input font_size_12"
                  suffix-icon="el-icon-search"
                  autocomplete="off"
                  clearable
                  v-model="CategoryVal"
                  :placeholder="$t('OrganizationalManagement.EnterGroupName')"
                ></el-input>
                <!-- suffix-icon="el-icon-search" -->
              </div>
            </div>
            <button class="btn_blue flex_center search_btn">
              <!-- <img src="../../assets/img/detail/btn_ic5.png" /> -->
              {{ $t("OrganizationalManagement.Search") }}
            </button>
          </div>
          <div class="his_sel_box" style="width: 100%">
            <el-table
              class="spec_table table_height_30 table_font_size_14 table_contentHeight_40"
              ref="OrderList"
              :data="OrderList"
              border
              empty-text="No Data"
              style="width: 100%"
            >
              <!-- 空数据状态的插槽 -->
              <template slot="empty">No Data</template>
              <el-table-column
                :label="$t('OrganizationalManagement.GroupID')"
                type="index"
                width="60"
                align="center"
                show-overflow-tooltip
                :resizable="false"
              />
              <el-table-column
                :label="$t('OrganizationalManagement.GroupName')"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />
              <el-table-column
                :label="$t('OrganizationalManagement.ParentGroupName')"
                prop="parentGroupName"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />
              <el-table-column
                :label="$t('OrganizationalManagement.Organization')"
                prop="organization"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.organization }}</div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('OrganizationalManagement.NumberofGroups')"
                prop="numberOfGroups"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />
              <el-table-column
                :label="$t('OrganizationalManagement.GroupStatus')"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              >
                <template slot-scope="scope">
                  <div class="ellipsis">{{ scope.row.groupStatus }}</div>
                </template>
              </el-table-column>

              <el-table-column
                :label="$t('OrganizationalManagement.Operation')"
                align="center"
                show-overflow-tooltip
                :resizable="false"
                class-name="company_link"
              >
                <template slot-scope="scope">
                  <div class="flex_center">
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      :visible-arrow="false"
                      effect="light"
                      content="Edit"
                      placement="top"
                    >
                      <div
                        class="oper_down"
                        @click="groupsDown(scope.row, 'edit')"
                      >
                        <svg
                          t="1724306616702"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7308"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M769.824 291.542L666.519 188.237c-15.802-15.802-41.421-15.799-57.224 0l-361.94 361.94c-12.357 12.358-11.885 12.825-11.889 39.389-0.005 132.545 0.064 132.965 0.064 132.965s0.42 0.07 132.969 0.065c26.561 0 27.027 0.468 39.39-11.891L769.824 348.77c15.805-15.802 15.809-41.421 0-57.228zM394.826 664.313c-14.95 14.949-15.478 14.416-45.967 14.416-69.291 0-69.404-0.117-69.404-0.117s-0.121-0.114-0.121-69.409c0-30.489-0.529-31.017 14.416-45.963l240.425-240.425 101.071 101.076-240.42 240.422z m270.149-270.151L563.903 293.086l46.567-46.566c27.437-27.437 27.852-27.023 54.879 0.006l46.187 46.187c27.033 27.026 27.447 27.442 0.007 54.885l-46.568 46.564zM811.435 718.375H637.664c-11.609 0-21.02-9.411-21.02-21.021 0-11.611 9.41-21.021 21.02-21.021h173.771c11.612 0 21.021 9.41 21.021 21.021 0 11.61-9.409 21.021-21.021 21.021zM811.435 847.612H256.487c-11.612 0-21.021-9.411-21.021-21.021 0-11.609 9.408-21.021 21.021-21.021h554.947c11.612 0 21.021 9.411 21.021 21.021 0.001 11.61-9.408 21.021-21.02 21.021z"
                            fill="#1296db"
                            p-id="7309"
                          ></path>
                        </svg>
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      :visible-arrow="false"
                      effect="light"
                      content="Delete"
                      placement="top"
                    >
                      <div
                        class="oper_down"
                        @click="groupsDown(scope.row, 'delete')"
                        style="margin-left: 30px"
                      >
                        <svg
                          t="1724306749336"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7557"
                          width="30"
                          height="30"
                        >
                          <path
                            d="M386.990351 752.645802L386.990351 359.958188c0-9.866718-8.003606-17.84953-17.851285-17.84953-9.849726 0-17.850261 7.982812-17.850261 17.84953l0 392.687614c0 9.850345 8.000536 17.851577 17.850261 17.851577C378.986745 770.497379 386.990351 762.496148 386.990351 752.645802zM529.793466 752.645802L529.793466 359.958188c0-9.866718-8.003606-17.84953-17.853331-17.84953-9.846656 0-17.848215 7.982812-17.848215 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.848215 17.851577C521.788837 770.497379 529.793466 762.496148 529.793466 752.645802zM815.393554 324.259128c-9.845632 0-17.846168 7.983835-17.846168 17.84953l0 481.935264c0 19.697621-15.987768 35.700083-35.702569 35.700083L262.038521 859.744006c-19.715825 0-35.700523-16.002462-35.700523-35.700083L226.337999 342.109682c0-9.866718-8.001559-17.84953-17.850261-17.84953-8.3014 0-15.271424 5.681396-17.26286 13.373589-0.194436-0.107447-0.396036-0.204661-0.588425-0.316202l0 486.72843c0 39.429011 31.953022 71.39812 71.401046 71.39812l499.806295 0c39.430627 0 71.401046-31.969109 71.401046-71.39812L833.244839 342.109682C833.245862 332.242963 825.244303 324.259128 815.393554 324.259128zM869.04872 199.312418L663.473431 199.312418l-65.856545-65.853847c-3.810948-3.811816-8.844798-5.641487-13.840783-5.52176-0.146339-0.00307-0.287561-0.021489-0.4339-0.021489L440.541135 127.915321c-0.128942 0-0.254814 0.016373-0.382732 0.019443-4.979612-0.105401-9.991971 1.726318-13.789616 5.523807l-65.856545 65.853847L154.93593 199.312418c-9.848702 0-17.849238 7.984858-17.849238 17.850553 0 9.849322 8.000536 17.850553 17.849238 17.850553l214.203137 0c0.225137 0 0.444133-0.025583 0.667223-0.033769 5.0799 0.190335 10.221201-1.633197 14.097644-5.508457l65.856545-65.85487 124.462669 0 65.856545 65.85487c3.875419 3.876284 9.017744 5.698792 14.09662 5.508457 0.224113 0.008186 0.44311 0.033769 0.667223 0.033769l214.202113 0c9.848702 0 17.849238-8.001231 17.849238-17.850553C886.898981 207.297276 878.897422 199.312418 869.04872 199.312418zM672.592487 752.645802L672.592487 359.958188c0-9.866718-7.998489-17.84953-17.848215-17.84953s-17.851285 7.982812-17.851285 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.851285 17.851577S672.592487 762.496148 672.592487 752.645802z"
                            fill="#F56B6B"
                            p-id="7558"
                          ></path>
                        </svg>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div
              v-if="page.total > page.pageSize"
              style="text-align: center; padding-top: 20px"
            >
              <span class="contclass show_All" @click="apptablelist">{{
                $t("OrganizationalManagement.ShowMore")
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- New Group 弹框 -->
    <el-dialog
      :visible.sync="timesDetailDialog"
      center
      :close-on-click-modal="true"
      custom-class="dialog_normal account_dialog"
      :append-to-body="true"
    >
      <div class="detail_cont">
        <div class="popTitle">
          {{ $t("OrganizationalManagement.NewGroup") }}
        </div>
        <div class="detail_pop_list">
          <el-form ref="form" :model="form">
            <el-form-item :label="$t('OrganizationalManagement.GroupName')">
              <el-input autocomplete="off" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('OrganizationalManagement.ParentGroupName')"
            >
              <el-select v-model="form.region" placeholder="">
                <el-option
                  :label="item.groupName"
                  :value="item.id"
                  v-for="(item, index) in productOptions"
                  :key="index"
                ></el-option>
              </el-select>
              <!-- <el-cascader
               style="width:100%"
                placeholder="Parent Group Name:"
                collapse-tags
                v-model="form.region"
                :options="productOptions"
                :props="optionsProps"
                :show-all-levels="false"
                popper-class="head_cas"
              ></el-cascader> -->
            </el-form-item>
            <el-form-item :label="$t('OrganizationalManagement.Organization')">
              <el-input
                autocomplete="off"
                v-model="form.Organization"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('OrganizationalManagement.NumberofGroups')"
            >
              <el-input autocomplete="off" v-model="form.groups"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('OrganizationalManagement.GroupStatus')"
              class="radio_item"
            >
              <el-radio-group v-model="form.resource">
                <el-radio :label="true">{{
                  $t("OrganizationalManagement.Valid")
                }}</el-radio>
                <el-radio :label="false">{{
                  $t("OrganizationalManagement.Invalid")
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div class="txt_right flex_center">
            <button class="btn_export export_gray mr30" @click="quxiao">
              {{ $t("OrganizationalManagement.Cancel") }}
            </button>
            <button class="btn_export" type="primary" @click="onSubmit">
              {{ $t("OrganizationalManagement.Confirm") }}
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import {
  getGroupList,
  getUserList,
  getRoleById,
  editSonUserInfo,
  editRoleInfo,
  getRoleList,
  getaddGroup,
  userGroupUpdate,
  userGroupDelete,
  getGroupTreeList,
  addSonUserInfo,
  addRole,
  getPermissionList,
} from "@/api/userApi";
import ReLogin from "../../../components/ReLogin.vue";

export default {
  mixins: [mixins1],
  components: {
    ReLogin,
  },
  data() {
    return {
      reLoginVis: false,
      form: {
        name: "",
        Organization: "",
        region: "",
        groups: "",
        resource: false,
        rolename: "",
        rolepostion: "",

        userrole: "",
        userGroup: "",
        username: "",
        delivery: false,
        usertart: false,
        rolestart: "0",
        type: true,
      },
      timesDetailDialog: false,
      value1: "",
      CategoryVal: "",
      IndicatorsValType: "",
      type: [],
      productOptions: [],
      IndicatorsValStatus: "",
      optionsProps: {
        label: "name", //名称展示
        value: "id", //值展示
        multiple: true,
        checkStrictly: true,
        // checkStrictly: true, //是否严格的遵守父子节点不互相关联
        expandTrigger: "click", //次级菜单的展开方式
        emitPath: false,
      },
      OrderList: [],
      window: window,
      qufen: true,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {
    this.getportfoillist();
  },

  methods: {
    getportfoillist() {
      const params = {
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      };
      getGroupList(params)
        .then((res) => {
          if (res.data) {
            this.OrderList = res.data.rows;
            this.productOptions = [...res.data.rows];
            this.page.total = res.data.total;
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    async searchHistory() {
      this.id = "";
      this.form.name = "";
      this.form.Organization = "";
      this.form.groups = "";
      (this.form.resource = false), (this.form.region = "");
      this.timesDetailDialog = true;
      this.qufen = true;

      // 获取下拉
      // let tree = await getGroupTreeList();
      // if (tree.code) {
      //     // this.select = tree.data
      //     // 转换替换数据
      //     this.productOptions = JSON.parse(JSON.stringify(tree.data).replace(/list/g, 'children'));
      // }
    },
    groupsDown(scope, value) {
      // this.getportfoillist()
      // this.timesDetailDialog = true;
      if (value == "edit") {
        let index = this.productOptions.findIndex(
          (item) => item.id == scope.id,
        );

        if (index != -1) {
          this.productOptions.splice(index, 1);
        }
        this.searchHistory();
        this.qufen = false;
        this.id = scope.id;

        this.form.name = scope.groupName;
        this.form.Organization = scope.organization;
        this.form.groups = scope.numberOfGroups;
        (this.form.resource = scope.groupStatus == "Valid" ? true : false),
          (this.form.region = "");
      } else {
        userGroupDelete({
          groupId: scope.id,
        }).then((res) => {
          if (res.code == 200) {
            this.getportfoillist();
            this.$message({
              message: res.msg,
              center: true,
              type: "success",
            });
          }
        });
      }
    },
    async onSubmit() {
      let par = {
        id: this.id,
        groupName: this.form.name,
        parentGroupId: this.form.region,
        organization: this.form.Organization,
        groupStatus: this.form.resource ? "Valid" : "Invalid",
        numberOfGroups: this.form.groups,
      };
      if (this.qufen) {
        getaddGroup(par).then((res) => {
          if (res.code) {
            this.$message({
              message: res.msg,
              center: true,
              type: "success",
            });
            this.getportfoillist();
          } else {
            this.$message({
              message: res.msg,
              center: true,
              type: "error",
            });
          }
        });
      } else {
        userGroupUpdate(par).then((res) => {
          if (res.code) {
            this.$message({
              message: res.msg,
              center: true,
              type: "success",
            });
            this.getportfoillist();
          } else {
            this.$message({
              message: res.msg,
              center: true,
              type: "false",
            });
          }
        });
      }
      this.timesDetailDialog = false;
    },
    quxiao() {
      this.timesDetailDialog = false;
    },
    apptablelist() {
      this.page.pageSize = this.page.pageSize + 5;
      this.getportfoillist();
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}

.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}

.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: "Arial Bold";
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;

  background: #1290c9;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}
@media screen and (max-width: 1441px) {
  .btn_blue {
    font-size: 14px;
  }
  .add_btn {
    width: max-content;
  }
}
.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  /* width: 1.2857142857142858rem; */
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box {
  margin-right: 1.7857142857142858rem;
  /* width: 23.928571428571427rem; */
  height: 2.857142857142857rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc !important;
  border-radius: 0.5714285714285714rem;
  font-size: 1.1428571428571428rem;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem
    rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.28rem;
  height: 4.28rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.4285714285714286rem;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold";
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 1.4285714285714286rem;
  color: #8c939d;
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}

/deep/ .avatar {
  width: 5rem;
  height: 5rem;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1a2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

/deep/.el-form-item__label {
  width: 12.285714285714286rem;
  line-height: 2.857142857142857rem;
  margin-bottom: 0;
  text-align: left;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
}

/deep/.el-form-item__content {
  position: relative;
  font-size: 1.2857142857142858rem;
  margin-left: 12.285714285714286rem;
}

.detail_cont /deep/.el-select {
  display: inline-block;
  position: relative;
  width: 100%;
}

.popTitle {
  font-family: "Arial Bold";
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  line-height: 1.9285714285714286rem;
  text-align: left;
  margin-bottom: 1.4285714285714286rem;
}

/deep/ .el-radio__label {
  font-size: 1.2857142857142858rem;
  color: #1a2332;
}
</style>
